import { Injectable, NgZone } from '@angular/core';
import * as Rx from 'rxjs';
import { observeOn } from 'rxjs/operators';
import { enterZone, leaveZone } from './zone-utils';

// tslint:disable: validate-timers

@Injectable()
export class TimeUtils {
  constructor(private ngZone: NgZone) {}

  setTimeout(callback: (...args: any[]) => void, timeout: number): number {
    return this.ngZone.runOutsideAngular(() =>
      window.setTimeout(() => this.ngZone.run(callback), timeout),
    );
  }

  rxTimer(
    delay: number,
    periodOrScheduler: Rx.SchedulerLike | number | undefined = undefined,
    scheduler: Rx.SchedulerLike = Rx.asyncScheduler,
  ): Rx.Observable<number> {
    return Rx.timer(
      delay,
      periodOrScheduler,
      leaveZone(this.ngZone, scheduler),
    ).pipe(observeOn(enterZone(this.ngZone, scheduler)));
  }

  rxInterval(
    interval: number,
    scheduler: Rx.SchedulerLike = Rx.asyncScheduler,
  ): Rx.Observable<number> {
    return Rx.interval(interval, leaveZone(this.ngZone, scheduler)).pipe(
      observeOn(enterZone(this.ngZone, scheduler)),
    );
  }
}
